import { FC } from "react"

interface EstadoProps {
    estadoId: number
    className?: string
}
export const Estado: FC<EstadoProps> = ({
    estadoId,
    className
}) => {
    switch (estadoId) {
        case 1:
            return (
                <span className={`btn btn-sm nobtn-light-success fw-bolder ms-2 py-1 px-3 ${className}`}>
                    Activo
                </span>
            )
        case 2:
            return (
                <button className={`btn btn-sm nobtn-light-danger fw-bolder ms-2 py-1 px-3 ${className}`}>
                    Inactivo
                </button>
            )
        default:
            return (
                <button className={`btn btn-sm nobtn-light-danger fw-bolder ms-2 py-1 px-3 ${className}`}>
                    N/A
                </button>
            )
    }
}
